import React from 'react'
import {Box, Button, Card, Skeleton, Stack, Typography} from '@mui/material'
import DeltaBadge from 'components/Page/Dashboard/DeltaBadge'
import Sparkline from 'components/Page/Dashboard/Sparkline'

const KpiCard = ({
    label,
    value,
    unit,
    delta,
    deltaSuffix,
    deltaLabel,
    goodWhen,
    helper,
    spark,
    sparkColor,
    sparkFilled,
    sparkDomain,
    action,
    loading,
}) => (
    <Card sx={{height: '100%'}}>
        <Stack sx={{p: {xs: 1.75, sm: 2.5}, height: '100%'}} spacing={1}>
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
                {label}
            </Typography>
            {loading ? (
                <>
                    <Skeleton variant="text" width={120} height={44} />
                    <Skeleton variant="text" width={150} />
                    <Skeleton variant="rounded" height={40} />
                </>
            ) : (
                <>
                    <Stack direction="row" spacing={0.75} alignItems="baseline">
                        <Typography
                            variant="h4"
                            fontWeight={700}
                            sx={{lineHeight: 1.2, fontSize: {xs: '1.5rem', sm: '2.125rem'}}}>
                            <bdi>{value}</bdi>
                        </Typography>
                        {unit && (
                            <Typography variant="body2" color="text.secondary" fontWeight={600}>
                                <bdi>{unit}</bdi>
                            </Typography>
                        )}
                    </Stack>
                    <Box sx={{minHeight: 20}}>
                        {delta !== undefined ? (
                            <DeltaBadge
                                value={delta}
                                suffix={deltaSuffix}
                                goodWhen={goodWhen}
                                label={deltaLabel}
                            />
                        ) : (
                            <Typography variant="caption" color="text.secondary">
                                {helper}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{flex: 1}} />
                    {spark?.length > 1 && (
                        <Sparkline
                            data={spark}
                            color={sparkColor}
                            filled={sparkFilled}
                            domain={sparkDomain}
                        />
                    )}
                    {action && (
                        <Button
                            size="small"
                            onClick={action.onClick}
                            sx={{alignSelf: 'flex-start', textTransform: 'none', px: 0}}>
                            {action.label} →
                        </Button>
                    )}
                </>
            )}
        </Stack>
    </Card>
)

export default KpiCard
